var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.$session.roles.includes('relations_view'))?_c('router-link',{attrs:{"to":{
			name: 'relationProjectOverview',
			params: { relationId: this.relationId },
		}},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):[_vm._v(_vm._s(_vm.text))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }